import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MsgboxEnum } from './msgbox.enum';
import { ensureValidArray } from '../../helpers/ensureValidArray';

@Component({
    selector: 'lib-shared-msgbox',
    imports: [MatDialogModule, MatButton],
    templateUrl: './msgbox.component.html',
    styleUrls: ['./msgbox.component.scss']
})
export class LibSharedMsgboxComponent {
	MsgboxEnum = MsgboxEnum;

	// prettier-ignore
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {
			title: string;
			message: string
			buttons?: [MsgboxEnum];
		},
		private dialogRef: MatDialogRef<LibSharedMsgboxComponent>
	) {
	}

	get title(): string {
		return this.data.title;
	}

	get message(): string {
		return this.data.message;
	}

	get buttons(): any {
		if (!ensureValidArray(this.data.buttons)) {
			this.data.buttons = [MsgboxEnum.CLOSE];
		}
		return this.data.buttons;
	}

	close(selection: MsgboxEnum): void {
		this.dialogRef.close(selection);
	}
}
